import React from "react";
import { Avatar, Typography, useMediaQuery } from "@mui/material";
import "./Perspectives.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { perspectiveData } from "./perspectivesData";
import { responsive } from "./perspectivesData";

const Perspectives = () => {
  // Screen Size
  const isMediumScreen = useMediaQuery(" (max-width:768px) ");
  const isMoreMediumScreen = useMediaQuery(" (min-width:768px) ");

  return (
    <>
      <div className="perspective_title d-flex flex-row align-items-center gap-2">
        <img style={{ width: "60px" }} src='/Assets/Images/mLogo.webp' alt="" />
        <Typography
          sx={{
            fontFamily: "'Archivo', sans-serif",
            fontWeight: 700,
            letterSpacing: "0.76px",
            fontSize: "14px",
            lineHeight: "12.6px",
            textAlign: "start",
          }}
        >
          More MinEmi Perspectives{" "}
        </Typography>
      </div>
      <Typography
        sx={{
          fontSize: 20,
          lineHeight: "26px",
          color: "#59266d",
          fontWeight: 400,
          fontFamily: "'Archivo', sans-serif",
        }}
      >
        Where can people run into trouble with a balance transfer?
      </Typography>

      <Carousel
        className=" pb-5"
        showDots={isMoreMediumScreen}
        responsive={responsive}
        infinite={true}
        autoPlaySpeed={1000}
        autoPlay={true}
        transitionDuration={2500}
        removeArrowOnDeviceType={["tablet", "mobile"]}
      >
        {/* perspective card one */}
        <div className="perspective_box d-flex flex-column flex-md-row gap-3 p-4 mt-3 rounded-2 ">
          <div className="perspective_content d-flex flex-column px-3 py-0 gap-2 ">
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                // color: "#ffffff",
                color: "#000",
                fontWeight: 500,
                fontFamily: "'Archivo', sans-serif",
                textAlign: "start",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  // color: "#fff",
                  color: "#000",
                }}
                className="archivo"
              >
                "
              </span>
              {perspectiveData[0].paraOne}
            </Typography>
          </div>
          <div className=" d-flex flex-row flex-md-column align-items-center align-items-md-end">
            <Avatar
              src=""
              alt=""
              sx={{
                width: isMediumScreen ? 50 : 111,
                height: isMediumScreen ? 50 : 111,
              }}
            />
            <Typography
              sx={{
                fontSize: "13px",
                lineHeight: "20px",
                fontWeight: 500,
                // color: "#fff",
                color: "#000",
                fontFamily: "'Archivo',sans-serif",
              }}
              className=" mt-md-3 ps-3"
            >
              {perspectiveData[0].name}, {perspectiveData[0].position}
            </Typography>
          </div>
        </div>

        {/* perspective card two */}
        <div className="perspective_box d-flex flex-column flex-md-row gap-3 p-4 mt-3 rounded-2">
          <div className="perspective_content d-flex flex-column px-3 py-0 gap-2">
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                // color: "#ffffff",
                color: "#000",
                fontWeight: 500,
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  // color: "#fff",
                  color: "#000",
                }}
                className="archivo"
              >
                "
              </span>
              {perspectiveData[1].paraOne}
            </Typography>
          </div>
          <div className=" d-flex flex-row flex-md-column align-items-center align-items-md-end">
            <Avatar
              src=""
              alt=""
              sx={{
                width: isMediumScreen ? 50 : 111,
                height: isMediumScreen ? 50 : 111,
              }}
            />
            <Typography
              sx={{
                fontSize: "13px",
                lineHeight: "20px",
                fontWeight: 500,
                // color: "#fff",
                color: "#000",
                fontFamily: "'Archivo',sans-serif",
              }}
              className=" mt-md-3 ps-3"
            >
              {perspectiveData[1].name}, {perspectiveData[1].position}
            </Typography>
          </div>
        </div>
      </Carousel>
    </>
  );
};

export default Perspectives;
